/* ============================================================
   phone-guard.js: phone country-code validation for all forms
   Added 2026-06-09. Enhances every <input type="tel"> with a
   country-flag dial-code selector (intl-tel-input) and validates
   the number against the chosen country on submit, so a number
   cannot be submitted with a mismatched country code (e.g. an
   African number forced to use the correct African code).
   Loads the library only when a phone field exists. Degrades
   gracefully: if the CDN fails, the form still submits.
   10 Oct 2026: intl-tel-input 23.8.0 takes the utils URL as utilsScript; the
   loadUtils option used before belongs to a later major version and was
   ignored, so numbers were neither checked nor sent with their country code.
   Regional readiness pass (23 Sept 2026): the flag defaults to the
   store's own country (Malaysia) instead of the Philippines, the
   preferred list covers the export markets, and when a form also
   carries a country select the flag follows the buyer's choice.
   ============================================================ */
(function () {
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var phones = document.querySelectorAll('input[type="tel"]');
    if (!phones.length) return;

    var VER = '23.8.0';
    var CSS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + VER + '/build/css/intlTelInput.css';
    var JS  = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + VER + '/build/js/intlTelInput.min.js';
    var UTILS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + VER + '/build/js/utils.js';

    var link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = CSS;
    document.head.appendChild(link);

    var s = document.createElement('script');
    s.src = JS;
    s.onload = function () { for (var i = 0; i < phones.length; i++) enhance(phones[i], UTILS); };
    s.onerror = function () { /* CDN failed: leave native form behaviour intact */ };
    document.head.appendChild(s);
  });

  /* Country names as used by the lead-form selects, mapped to ISO 3166-1 alpha-2. */
  var ISO = {"Malaysia":"my","Indonesia":"id","Philippines":"ph","Thailand":"th","Vietnam":"vn","Myanmar":"mm","Cambodia":"kh","Laos":"la","Brunei":"bn","Singapore":"sg","Timor-Leste":"tl","Papua New Guinea":"pg","Solomon Islands":"sb","Fiji":"fj","Vanuatu":"vu","Samoa":"ws","Tonga":"to","New Caledonia":"nc","Australia":"au","New Zealand":"nz","India":"in","Sri Lanka":"lk","Bangladesh":"bd","Pakistan":"pk","Nepal":"np","Bhutan":"bt","Maldives":"mv","Afghanistan":"af","China":"cn","Hong Kong SAR":"hk","Taiwan":"tw","Japan":"jp","South Korea":"kr","Mongolia":"mn","Macao SAR":"mo","United Arab Emirates":"ae","Saudi Arabia":"sa","Oman":"om","Qatar":"qa","Kuwait":"kw","Bahrain":"bh","Yemen":"ye","Iraq":"iq","Iran":"ir","Jordan":"jo","Lebanon":"lb","Syria":"sy","Israel":"il","Palestine":"ps","Türkiye":"tr","Egypt":"eg","Libya":"ly","Tunisia":"tn","Algeria":"dz","Morocco":"ma","Sudan":"sd","Nigeria":"ng","Ghana":"gh","Côte d'Ivoire":"ci","Senegal":"sn","Mali":"ml","Burkina Faso":"bf","Niger":"ne","Guinea":"gn","Guinea-Bissau":"gw","Sierra Leone":"sl","Liberia":"lr","Togo":"tg","Benin":"bj","The Gambia":"gm","Cabo Verde":"cv","Mauritania":"mr","Cameroon":"cm","Gabon":"ga","Republic of the Congo":"cg","Democratic Republic of the Congo":"cd","Central African Republic":"cf","Chad":"td","Equatorial Guinea":"gq","São Tomé and Príncipe":"st","Kenya":"ke","Tanzania":"tz","Uganda":"ug","Rwanda":"rw","Burundi":"bi","Ethiopia":"et","Eritrea":"er","Djibouti":"dj","Somalia":"so","South Sudan":"ss","Madagascar":"mg","Mauritius":"mu","Seychelles":"sc","Comoros":"km","South Africa":"za","Namibia":"na","Botswana":"bw","Zimbabwe":"zw","Zambia":"zm","Malawi":"mw","Mozambique":"mz","Angola":"ao","Lesotho":"ls","Eswatini":"sz","Mexico":"mx","Guatemala":"gt","Belize":"bz","Honduras":"hn","El Salvador":"sv","Nicaragua":"ni","Costa Rica":"cr","Panama":"pa","Colombia":"co","Venezuela":"ve","Ecuador":"ec","Peru":"pe","Bolivia":"bo","Brazil":"br","Paraguay":"py","Uruguay":"uy","Argentina":"ar","Chile":"cl","Guyana":"gy","Suriname":"sr","Cuba":"cu","Dominican Republic":"do","Haiti":"ht","Jamaica":"jm","Trinidad and Tobago":"tt","Puerto Rico":"pr","Barbados":"bb","Bahamas":"bs","Antigua and Barbuda":"ag","Dominica":"dm","Grenada":"gd","Saint Lucia":"lc","Saint Kitts and Nevis":"kn","Saint Vincent and the Grenadines":"vc","United Kingdom":"gb","Ireland":"ie","France":"fr","Germany":"de","Netherlands":"nl","Belgium":"be","Luxembourg":"lu","Spain":"es","Portugal":"pt","Italy":"it","Switzerland":"ch","Austria":"at","Denmark":"dk","Sweden":"se","Norway":"no","Finland":"fi","Iceland":"is","Poland":"pl","Czechia":"cz","Slovakia":"sk","Hungary":"hu","Romania":"ro","Bulgaria":"bg","Greece":"gr","Croatia":"hr","Slovenia":"si","Serbia":"rs","Bosnia and Herzegovina":"ba","Montenegro":"me","North Macedonia":"mk","Albania":"al","Kosovo":"xk","Estonia":"ee","Latvia":"lv","Lithuania":"lt","Ukraine":"ua","Moldova":"md","Belarus":"by","Russia":"ru","Georgia":"ge","Armenia":"am","Azerbaijan":"az","Cyprus":"cy","Malta":"mt","Kazakhstan":"kz","Uzbekistan":"uz","Turkmenistan":"tm","Kyrgyzstan":"kg","Tajikistan":"tj","United States":"us","Canada":"ca"};

  /* Validation message in the page language (10 Oct 2026): Malay on /ms, Indonesian on /id and /id-id. */
  function pageLang(){
    var l = (document.documentElement.lang || 'en').split('-')[0].toLowerCase();
    return (l === 'ms' || l === 'id') ? l : 'en';
  }
  var MSG = {
    en: { bad: function (c) { return 'That number does not look valid for ' + c + '. Pick your country flag and enter the correct country code.'; }, any: 'the selected country', short: 'Invalid phone number for the selected country.' },
    ms: { bad: function (c) { return 'Nombor ini nampaknya tidak sah untuk ' + c + '. Pilih bendera negara anda dan masukkan kod negara yang betul.'; }, any: 'negara yang dipilih', short: 'Nombor telefon tidak sah untuk negara yang dipilih.' },
    id: { bad: function (c) { return 'Nomor ini tampaknya tidak valid untuk ' + c + '. Pilih bendera negara Anda dan masukkan kode negara yang benar.'; }, any: 'negara yang dipilih', short: 'Nomor telepon tidak valid untuk negara yang dipilih.' }
  };

  function defaultCountry(){
    try { if (window.Shopify && Shopify.country) return String(Shopify.country).toLowerCase(); } catch (e) {}
    return 'my';
  }

  function enhance(input, utilsUrl) {
    if (!window.intlTelInput || input.dataset.phoneGuard) return;
    input.dataset.phoneGuard = '1';

    var iti = window.intlTelInput(input, {
      initialCountry: defaultCountry(),
      preferredCountries: ['my','id','ph','th','vn','in','ng','ke','gh','za','co','ae','sa','eg'],
      separateDialCode: true,
      autoPlaceholder: 'off', /* CS v29, 23 Oct 2026 (LOOK-07): no sample number such as 555-0123 in the field */
      utilsScript: utilsUrl
    });

    var msg = document.createElement('div');
    msg.className = 'phone-guard__err';
    msg.setAttribute('role', 'alert');
    msg.style.cssText = 'display:none;color:#dc2626;font-size:13px;margin-top:6px;';
    if (input.parentNode && input.parentNode.parentNode) {
      input.parentNode.parentNode.insertBefore(msg, input.parentNode.nextSibling);
    }

    function clearErr(){ msg.style.display='none'; input.setCustomValidity(''); }
    input.addEventListener('input', clearErr);
    input.addEventListener('countrychange', clearErr);

    var form = input.closest('form');

    /* Follow the buyer's country choice: when the same form has a country select and the
       phone field is still empty, switch the flag and dial code to that country. */
    /* 23 Oct 2026: the quote form names the field contact[Country]; match either case. */
    var countrySelect = form ? form.querySelector('select[name="contact[Country]"], select[name="contact[country]"]') : null;
    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        var iso = ISO[countrySelect.value];
        if (iso && (input.value || '').trim() === '' && typeof iti.setCountry === 'function') {
          try { iti.setCountry(iso); } catch (e) {}
        }
      });
    }
    if (form && !form.dataset.phoneGuardForm) {
      form.dataset.phoneGuardForm = '1';
      form.addEventListener('submit', function (e) {
        var val = (input.value || '').trim();
        if (val === '') return; // phone optional on some forms
        if (typeof iti.isValidNumber === 'function' && iti.isValidNumber() === false) {
          e.preventDefault();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          var t = MSG[pageLang()];
          var country = (typeof iti.getSelectedCountryData === 'function') ? (iti.getSelectedCountryData().name || t.any) : t.any;
          msg.textContent = t.bad(country);
          msg.style.display = 'block';
          input.setCustomValidity(t.short);
          input.reportValidity();
          input.focus();
          return false;
        }
        if (typeof iti.getNumber === 'function') {
          var full = iti.getNumber();
          if (full) input.value = full; // submit full international (E.164) number
        }
      }, true); // capture: run before the form's other submit handlers
    }
  }
})();
